import _slicedToArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from 'react';
import { alpha } from '@mui/material/styles';
import { Link } from '@mui/docs/Link';
import FEATURE_TOGGLE from 'docs/src/featureToggle';
import PageContext from 'docs/src/modules/components/PageContext';
import { convertProductIdToName } from 'docs/src/modules/components/AppSearch';
import { jsx as _jsx } from "react/jsx-runtime";
var showSurveyMessage = false;
function isBlackFriday() {
  var today = Date.now();
  var start = new Date('2024-11-25').getTime();
  var end = new Date('2024-12-07T23:59:59Z').getTime();
  return today > start && today < end;
}
var hadHydrated = false;
export default function AppFrameBanner() {
  if (!FEATURE_TOGGLE.enable_docsnav_banner) {
    return null;
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  var _React$useState = React.useState(hadHydrated),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    mounted = _React$useState2[0],
    setMounted = _React$useState2[1];
  // eslint-disable-next-line react-hooks/rules-of-hooks
  React.useEffect(function () {
    hadHydrated = true;
    setMounted(true);
  }, []);

  // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
  // eslint-disable-next-line react-hooks/rules-of-hooks -- FEATURE_TOGGLE never changes
  var pageContext = React.useContext(PageContext);
  var productName = convertProductIdToName(pageContext) || 'MUI';
  var message = '';
  var href = '';
  if (showSurveyMessage) {
    message = "\uD83D\uDE80 Influence ".concat(productName, "'s 2025 roadmap! Participate in the latest Developer Survey");
    href = 'https://tally.so/r/mObbvk?source=website';
  } else if (mounted && isBlackFriday()) {
    message = "Black Friday is here! Don't miss out on the best offers of the year.";
    href = 'https://mui.com/store/bundles/?deal=black-friday&from=docs';
  }
  if (false) {
    if (message.length > 100) {
      throw new Error("Docs-infra: AppFrameBanner message is too long. It will overflow on smaller screens.");
    }
  }
  if (message === '' || href === '') {
    return null;
  }
  return /*#__PURE__*/_jsx(Link, {
    href: href,
    target: "_blank",
    variant: "caption",
    sx: [function (theme) {
      return {
        padding: theme.spacing('6px', 1.5),
        display: {
          xs: 'none',
          md: 'block'
        },
        fontWeight: 'medium',
        textWrap: 'nowrap',
        maxHeight: '34px',
        backgroundColor: alpha(theme.palette.primary[50], 0.8),
        border: '1px solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderRadius: 1,
        transition: 'all 150ms ease',
        '&:hover, &:focus-visible': {
          backgroundColor: alpha(theme.palette.primary[100], 0.4),
          borderColor: (theme.vars || theme).palette.primary[200]
        }
      };
    }, function (theme) {
      return theme.applyDarkStyles({
        backgroundColor: alpha(theme.palette.primary[900], 0.15),
        '&:hover, &:focus-visible': {
          backgroundColor: alpha(theme.palette.primary[900], 0.4),
          borderColor: (theme.vars || theme).palette.primary[900]
        }
      });
    }],
    children: message
  });
}